/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Apikeys_Copy_FailedInputs */

const en_settings_apikeys_copy_failed = /** @type {(inputs: Settings_Apikeys_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to copy, please copy manually`)
};

/**
* | output |
* | --- |
* | "Failed to copy, please copy manually" |
*
* @param {Settings_Apikeys_Copy_FailedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_apikeys_copy_failed = /** @type {((inputs?: Settings_Apikeys_Copy_FailedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Apikeys_Copy_FailedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_apikeys_copy_failed(inputs)
});
export { settings_apikeys_copy_failed as "settings.apikeys.copy_failed" }